export default {
  profile: state => state.profile,
};



// WEBPACK FOOTER //
// ./src/views/Profile/store/getters.js